export const consumirIntencionNuevo = () => {
  const url = new URL(window.location.href);
  if (url.searchParams.get("nuevo") !== "1") return false;

  url.searchParams.delete("nuevo");
  const query = url.searchParams.toString();
  const destino = `${url.pathname}${query ? `?${query}` : ""}${url.hash}`;
  window.history.replaceState(window.history.state, "", destino);
  return true;
};
